import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { USER, USERINFO } from '../../../../data/reducer';
import OTIcon from '../../../../components/tag/OTIcon';

let { id: module_id } = module;

const HpaContact = (props) => {
  const { userInfo, hpaContact } = props;

  if (hpaContact.data.phone === '' && hpaContact.data.email === '') {
    return <FormattedMessage id={'hpa.no.contacts.added'} />;
  }

  return (
    <>
      {hpaContact.data.phone && (
        <div>
          <FormattedMessage id={'phone.number'}>
            {(txt) => (
              <span className={'ot-hpa-contact-preview-label'}> {txt} </span>
            )}
          </FormattedMessage>
          <span className={'ot-hpa-contact-preview-field'}>
            {hpaContact.data.phone}
          </span>
        </div>
      )}

      {hpaContact.data.email && (
        <div>
          <FormattedMessage id={'email'}>
            {(txt) => (
              <span className={'ot-hpa-contact-preview-label'}> {txt} </span>
            )}
          </FormattedMessage>
          <span className={'ot-hpa-contact-preview-field'}>
            {hpaContact.data.email}
          </span>
        </div>
      )}

      <div>
        <FormattedMessage id={'hpa.notifications.title'}>
          {(txt) => (
            <span className={'ot-hpa-contact-preview-label'}> {txt} </span>
          )}
        </FormattedMessage>

        <FormattedMessage
          id={`${module_id}.hpa.contact.notifications.${hpaContact.data.notificationAgreement}`}
          values={{ name: userInfo.wholeName }}
        >
          {(txt) => (
            <span className={'ot-hpa-contact-preview-field'}> {txt} </span>
          )}
        </FormattedMessage>
      </div>

      <div className={'ot-hpa-contact-preview-info'}>
        <OTIcon
          config={{ type: 'fa' }}
          className={'ot-hpa-contact-preview-info__icon icon-exclamation-sign'}
        />

        <FormattedMessage
          id={'hpa.contact.info'}
          values={{ name: userInfo.wholeName }}
        >
          {(txt) => (
            <p className={'ot-hpa-contact-preview-info__text'}> {txt} </p>
          )}
        </FormattedMessage>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userInfo: state[USER].userInfo.data,
    hpaContact: state[USERINFO],
  };
};

export default connect(mapStateToProps)(HpaContact);
